import { useState } from 'react'
import { connect } from 'react-redux'
import { ModalBody } from 'reactstrap'
import apiService from 'utils/apiService'
import { updateNotificationSettings_action } from 'store/actions'
import { ModalForm, SettingsList } from 'modules/app/styles'
import { SwitchComponent } from './SwitchComponent'
import { handleApiError } from 'utils/helpers'
import { toast } from 'react-toastify'

export const NotificationSettings = (props) => {
  const { user } = props
  const notification_settings = user.notification_settings

  const [settings, set_settings] = useState({
    member_joined: notification_settings?.settings?.member_joined === undefined ? true : notification_settings?.settings?.member_joined,
    added_to_group: notification_settings?.settings?.added_to_group === undefined ? false : notification_settings?.settings?.added_to_group,
    page_mentioned: notification_settings?.settings?.page_mentioned === undefined ? false : notification_settings?.settings?.page_mentioned,
    page_comment_reply: notification_settings?.settings?.page_comment_reply === undefined ? true : notification_settings?.settings?.page_comment_reply,
    page_comment_mentioned: notification_settings?.settings?.page_comment_mentioned === undefined ? true : notification_settings?.settings?.page_comment_mentioned,
    new_page_in_category: notification_settings?.settings?.new_page_in_category === undefined ? true : notification_settings?.settings?.new_page_in_category,
    page_comment: notification_settings?.settings?.page_comment === undefined ? true : notification_settings?.settings?.page_comment,
    added_as_category_owner: notification_settings?.settings?.added_as_category_owner === undefined ? true : notification_settings?.settings?.added_as_category_owner,
    added_as_category_editor: notification_settings?.settings?.added_as_category_editor === undefined ? true : notification_settings?.settings?.added_as_category_editor,
    added_as_category_viewer: notification_settings?.settings?.added_as_category_viewer === undefined ? true : notification_settings?.settings?.added_as_category_viewer,
    new_response_in_category: notification_settings?.settings?.new_response_in_category === undefined ? true : notification_settings?.settings?.new_response_in_category,
    response_shortcut: notification_settings?.settings?.response_shortcut_add === undefined ? true : notification_settings?.settings?.response_shortcut_add
  })

  const updateSettings = async (data) => {
    try {
      const response = await apiService('notifications/settings', data, 'post', true)
      toast.success('Notification settings saved!')
      props.updateNotificationSettings(response.settings)
    } catch (error) {
      handleApiError(error)
    }
  }
  return (
    <ModalBody>
      <ModalForm>
        <div className='title'>Notifications</div>
        <br />
        <SettingsList>
          <li className='section-title'>General:</li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='member_joined'>
              When someone you invited joins your team's Base
            </label>
            <SwitchComponent label='member_joined' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='added_to_group'>
              When you've been added to a user group
            </label>
            <SwitchComponent label='added_to_group' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <hr />

          <li className='section-title'>Mentions:</li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='page_mentioned'>
              When you're mentioned in a Page
            </label>
            <SwitchComponent label='page_mentioned' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='page_comment_reply'>
              When your comment is replied to
            </label>
            <SwitchComponent label='page_comment_reply' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='page_comment_mentioned'>
              When you're mentioned in a comment
            </label>
            <SwitchComponent label='page_comment_mentioned' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <hr />

          <li className='section-title'>Activity:</li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='new_response_in_category'>
              When a response is added in a category you're in
            </label>
            <SwitchComponent label='new_response_in_category' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='new_page_in_category'>
              The first time a new Page is published in a category you're in
            </label>
            <SwitchComponent label='new_page_in_category' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='page_comment'>
              When someone comments on a page you contributed to
            </label>
            <SwitchComponent label='page_comment' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='added_as_category_owner'>
              When you're added as an Owner of a category
            </label>
            <SwitchComponent label='added_as_category_owner' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='added_as_category_editor'>
              When you're added as an Editor of a category
            </label>
            <SwitchComponent label='added_as_category_editor' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='added_as_category_viewer'>
              When you're added as a Viewer of a category
            </label>
            <SwitchComponent label='added_as_category_viewer' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
          <li className='setting-item d-flex justify-content-between align-items-center'>
            <label className='mb-0' htmlFor='response_shortcut'>
              When a shortcut is added to a response
            </label>
            <SwitchComponent label='response_shortcut' settings={settings} set_settings={set_settings} updateSettings={updateSettings} />
          </li>
        </SettingsList>
      </ModalForm>
    </ModalBody>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user
})

const mapDispatchToProps = (dispatch) => ({
  updateNotificationSettings: (value) => dispatch(updateNotificationSettings_action(value))
})

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSettings)
